import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a875853&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=2a875853&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a875853",
  null
  
)

export default component.exports